import moment from 'moment-timezone'

function validateDateTime (dateTime, task, isValid) {
  let errorMessage = ''

  const changeMoment = moment(dateTime).tz('Europe/Warsaw')
  const taskLoadingMoment = moment(task.zaladunek).tz('Europe/Warsaw')
  const taskUnloadingMoment = moment(task.rozladunek).tz('Europe/Warsaw')

  task.stoppages?.map(s => {
    const stoppageArrivalMoment = moment(s.arrival).tz('Europe/Warsaw')
    const stoppageDepartureMoment = moment(s.departure).tz('Europe/Warsaw')

    if (changeMoment.isSameOrAfter(stoppageArrivalMoment) && changeMoment.isSameOrBefore(stoppageDepartureMoment)) {
      isValid = false
      errorMessage = 'Moment przepinki nie może nastąpić podczas postoju ciągnika'
    }

    if (changeMoment.isBefore(taskLoadingMoment)) {
      isValid = false
      errorMessage = 'Moment przepinki nie może nastąpić przed czasem załadunku zlecenia'
    }

    if (changeMoment.isAfter(taskUnloadingMoment)) {
      isValid = false
      errorMessage = 'Moment przepinki nie może nastąpić po czasie rozładunku zlecenia'
    }
  })

  return { isValid: isValid, errorMessage: errorMessage }
}

export { validateDateTime }
